import "./App.css"

import useFetch from "./hooks/useFetch"
import MainSection from "./sections/MainSection"
import useMediaQuery from "./hooks/useMediaQuery"
import CategorySection from "./sections/CategorySection"
import CustomSpinner from "./components/CustomSpinner"
import VideoSection from "./sections/VideoSection"

const App = () => {
  const { data, loading } = useFetch()
  const isDesktop = useMediaQuery("(min-width: 768px)")

  return (
    <div className="App">
      {loading ? (
        <div className="min-h-screen flex justify-center items-center">
          <CustomSpinner />
        </div>
      ) : (
        <>
          {/* Video Section */}
          <VideoSection src={data?.video} />
          
          {/* Main Section */}
          <MainSection data={data?.main} isDesktop={isDesktop} />

          {/* Moderate Trail Section */}
          <CategorySection data={data?.moderate_trail} isDesktop={isDesktop} />

          {/* Light Trail Section */}
          <CategorySection data={data?.light_trail} isDesktop={isDesktop} />

          {/* Outdoor Clothing Section */}
          <CategorySection
            desktopDisplay={2}
            isDesktop={isDesktop}
            data={data?.outdoor_clothing}
          />
        </>
      )}
    </div>
  )
}

export default App
